import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { FC } from "react";
import { IPopoverHelpTextProps } from "./types";
import Icon from "@portal/components/atoms/icons";

const PopoverHelpText: FC<IPopoverHelpTextProps> = ({ children, panelPosition = "bottom start" }) => {
  return (
    <Popover className="overflow-y-visible leading-none">
      <PopoverButton>
        <Icon name="questionMarkCircleIcon" size="xxsmall" hoverEffect />
      </PopoverButton>
      <PopoverPanel
        anchor={panelPosition}
        className="flex flex-col bg-zinc-50 dark:bg-gray-700 mt-2 z-20 border dark:border-greyDark rounded-md max-h-[400px] shadow-md p-4 overflow-y-auto"
      >
        <div className="max-w-lg">{children}</div>
      </PopoverPanel>
    </Popover>
  );
};

export default PopoverHelpText;
